import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { AppWindow, ChevronRight } from "lucide-react";
import { api } from "@/lib/api";
import { AppDataManager } from "@/components/apps/AppDataManager";

export const PortalAppDetail = () => {
  const { appId } = useParams();
  return <AppDataManager appId={appId} backTo="/portal/apps" backLabel="My apps" />;
};

export const AdminAppManager = () => {
  const { appId } = useParams();
  return <AppDataManager appId={appId} backTo={`/admin/studio/${appId}`} backLabel="Back to AI Studio" />;
};

export default function PortalApps() {
  const [apps, setApps] = useState(null);
  useEffect(() => { api.get("/manage/apps").then((r) => setApps(r.data)).catch(() => setApps([])); }, []);
  return (
    <div data-testid="portal-apps-page">
      <p className="font-mono-tech text-xs uppercase tracking-widest text-cyan-400">// my apps</p>
      <h1 className="mt-1 mb-6 text-3xl font-bold text-white">My apps</h1>
      {apps === null ? <p className="text-slate-500">Loading…</p> : !apps.length ? (
        <div data-testid="portal-apps-empty" className="rounded-2xl border border-dashed border-white/10 p-10 text-center text-slate-400">No apps yet. When we build an app for one of your projects, you'll manage its data here.</div>
      ) : (
        <div className="grid gap-4 sm:grid-cols-2">
          {apps.map((a) => (
            <Link key={a.id} to={`/portal/apps/${a.id}`} data-testid={`portal-app-${a.id}`} className="card-tech group flex items-center gap-4 rounded-2xl p-5 transition-colors hover:border-cyan-400/40">
              <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-cyan-400/10 text-cyan-300"><AppWindow className="h-5 w-5" /></span>
              <span className="min-w-0 flex-1">
                <span className="block truncate font-semibold text-white">{a.name}</span>
                <span className="block text-xs text-slate-500">{a.records} entries · {a.members} members{a.pending ? ` · ${a.pending} pending` : ""}</span>
              </span>
              <ChevronRight className="h-4 w-4 text-slate-500 transition-transform group-hover:translate-x-0.5" />
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
